var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('AirTransport_Component'),_c('Footer_Compontent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"airTransport"},[_c('div',{staticClass:"airTransport_Top"},[_c('div',{staticClass:"backgroundPicture"})])])
}]

export { render, staticRenderFns }